package cc.easyandroid.easycompose.mvi.rx.internal

import cc.easyandroid.easycompose.mvi.utils.internal.InternalMviKotlinApi


interface PublishSubject<T> : Subject<T>

@Suppress("FunctionNaming") // https://github.com/detekt/detekt/issues/6601

fun <T> PublishSubject(): PublishSubject<T> =
    PublishSubjectImpl()

@OptIn(InternalMviKotlinApi::class)
private class PublishSubjectImpl<T> : BaseSubject<T>(), PublishSubject<T>
